// src/services/counselorApi2.js
// FINAL CLEAN API — MATCHES GO BACKEND ROUTES

// ------------------------------------------------------
// BUILD BACKEND URL
// ------------------------------------------------------
let BASE =
  process.env.REACT_APP_BACKEND_ROOT ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:5001";

// remove trailing slash
BASE = BASE.replace(/\/+$/, "");

// ensure /api/v1 present
if (!BASE.endsWith("/api/v1")) BASE += "/api/v1";

const API_BASE_URL = BASE;

// ------------------------------------------------------
// HELPERS
// ------------------------------------------------------
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleResponse = async (res) => {
  let data = {};
  try {
    data = await res.json();
  } catch (_) {}

  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
};

// remove empty filters
const cleanFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(
      ([_, v]) => v !== "" && v !== null && v !== undefined && v !== 0
    )
  );

// ------------------------------------------------------
// MAIN API
// ------------------------------------------------------
export const studentBookingApi = {

  // =========================
  // COUNSELORS (PUBLIC)
  // =========================

  getPublishedCounselors: async (filters = {}) => {
    const params = new URLSearchParams(cleanFilters(filters)).toString();
    const res = await fetch(`${API_BASE_URL}/counselors?${params}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    return handleResponse(res);
  },

  getCounselorById: async (id) => {
    const res = await fetch(`${API_BASE_URL}/counselors/${id}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    return handleResponse(res);
  },

  // =========================
  // BOOKINGS (AUTH REQUIRED)
  // =========================

  createBookingOrder: async (bookingData) => {
    const res = await fetch(`${API_BASE_URL}/bookings/create-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(bookingData),
    });
    return handleResponse(res);
  },

  verifyBookingPayment: async (paymentData) => {
    const res = await fetch(`${API_BASE_URL}/bookings/verify-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(paymentData),
    });
    return handleResponse(res);
  },

  getMyBookings: async () => {
    const res = await fetch(`${API_BASE_URL}/bookings/my-bookings`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });
    return handleResponse(res);
  },

  cancelBooking: async (bookingId) => {
    const res = await fetch(`${API_BASE_URL}/bookings/${bookingId}/cancel`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });
    return handleResponse(res);
  },
};

// ------------------------------------------------------
// RAZORPAY HELPERS
// ------------------------------------------------------

// load checkout script
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

// open checkout
export const openRazorpayCheckout = (orderData, prefill = {}) => {
  return new Promise((resolve, reject) => {
    if (!window.Razorpay) {
      reject(new Error("Razorpay SDK not loaded"));
      return;
    }

    const options = {
      key: orderData.key_id,
      amount: orderData.amount,
      currency: "INR",
      name: "Vidyazon",
      description: "Counseling Session Booking",
      order_id: orderData.order_id,

      prefill: {
        name: prefill.name || "",
        email: prefill.email || "",
        contact: prefill.contact || "",
      },

      theme: { color: "#4F46E5" },

      handler: (response) => resolve(response),

      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", (res) =>
      reject(new Error(res.error?.description || "Payment failed"))
    );

    rzp.open();
  });
};